import { Observable } from 'rxjs';
import { AddressValidationResponse } from '@app/api/models/userData';

export abstract class IUserDataService {
  public abstract validateAddress(addressValidationData): Observable<AddressValidationResponse>;
}
